import React, { useState } from 'react';
import { FileDrop } from '@naf/input';
import * as S from './FileUpload.styles';

interface Props {
  disabled?: boolean;
  error: boolean;
  name: string;
  onChange: (e?: any) => void;
  extraMargin?: boolean;
}

export const FileInput = ({ disabled, error, name, onChange, extraMargin = false }: Props) => {
  const [files, setFiles] = useState<File[]>([]);

  return (
    <S.FileDropWrapper $extraMargin={extraMargin}>
      <S.StyledDocumentList files={files} setFiles={setFiles} $hasFiles={files.length > 0} />
      <FileDrop
        disabled={disabled}
        error={error}
        onChange={onChange}
        name={name}
        files={files}
        setFiles={setFiles}
        maxFiles={5}
      />
    </S.FileDropWrapper>
  );
};
